<template>
  <div
    style="text-wrap: balance; backdrop-filter: blur(16px)"
    class="isolate flex items-start gap-4 border px-4 pb-[14px] pt-3 sm:items-center pointer-events-none w-max text-white opacity-0 fixed z-50 max-w-[min(90vw,600px)] transition-opacity duration-500 bottom-10 left-1/2 -translate-x-1/2 rounded-2xl border-white/10 bg-gray-100/70"
    :class="{
      'pointer-events-auto opacity-100': show,
    }"
  >
    <div>
      Посещая данный сайт, вы принимаете условия использования cookie-файлов.
      <br />
      <a class="border-b border-white pb-px" target="_blank" href="/privacy-policy"> Подробнее </a>
    </div>
    <button class="btn btn-white btn-sm" @click="hideCookieNotice">Oк</button>
  </div>
</template>

<script>
export default {
  name: 'CookieNotice',

  data() {
    return {
      show: false,
    }
  },
  mounted() {
    this.show = localStorage.getItem('cookie-notice') == null
  },
  methods: {
    hideCookieNotice() {
      localStorage.setItem('cookie-notice', 'showed')
      this.show = false
    },
  },
}
</script>
